// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Fira+Code:wght@400;500;600;700&family=Fira+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
}

/* GPU-accelerate the main scrolling layer so wheel events don't repaint fixed glass elements */
body {
  -webkit-overflow-scrolling: touch;
}

/* Global Theme Variables (Animated Glass Theme) */
:root {
  /* Light Mode Base */
  --bg-primary: #f8fafc;
  --bg-glass: rgba(255, 255, 255, 0.7);
  --bg-glass-heavy: rgba(255, 255, 255, 0.85);
  --border-glass: rgba(255, 255, 255, 0.5);
  --bg-secondary: rgba(248, 250, 252, 0.6);
  --bg-tertiary: rgba(241, 245, 249, 0.6);

  /* Text */
  --text-primary: #0F172A;
  --text-secondary: #475569;
  --text-heading: #020617;

  /* Accents */
  --accent-primary: #2563EB;
  /* Trust Blue */
  /* Backward-compatible alias: some page CSS still uses --accent-color */
  --accent-color: var(--accent-primary);
  --accent-hover: #1D4ED8;
  --accent-warning: #D97706;
  --accent-success: #059669;
  --accent-error: #DC2626;

  /* Borders and UI */
  --border-color: #E2E8F0;
  --border-focus: rgba(37, 99, 235, 0.4);

  /* Shadows and Effects */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --glow-text: none;
  --glow-accent: none;

  /* Typography */
  --font-body: 'Fira Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-heading: 'Inter', 'Fira Code', monospace;
  --font-data: 'Fira Code', monospace;

  color-scheme: light;
}

/* ============================================================
   ТЁМНАЯ ТЕМА (доступна только роли DEV — переключатель в навбаре)
   Переопределяем базовые токены дизайн-системы. Все компоненты,
   которые используют var(--token), автоматически становятся
   тёмными. Специфичность :root[data-theme='dark'] выше, чем у
   :root в других файлах, поэтому переопределение всегда выигрывает.
   ============================================================ */
:root[data-theme='dark'] {
  /* Поверхности */
  --bg-primary: #1e293b;
  --bg-glass: rgba(30, 41, 59, 0.72);
  --bg-glass-heavy: rgba(15, 23, 42, 0.9);
  --border-glass: rgba(148, 163, 184, 0.14);
  --bg-secondary: #1e293b;
  --bg-tertiary: #273449;
  --bg-card: rgba(30, 41, 59, 0.78);

  /* Текст — высокий контраст, чтобы ничего не сливалось */
  --text-primary: #f1f5f9;
  --text-secondary: #aab7cc;
  --text-heading: #f8fafc;
  --text-muted: #8b98ae;
  --text-main: #f1f5f9;

  /* Акценты — чуть ярче для тёмного фона */
  --accent-primary: #3b82f6;
  --accent-color: var(--accent-primary);
  --accent-hover: #60a5fa;
  --accent-warning: #fbbf24;
  --accent-success: #34d399;
  --accent-error: #f87171;

  /* Границы */
  --border-color: #334155;
  --border-light: rgba(148, 163, 184, 0.14);
  --border-focus: rgba(59, 130, 246, 0.55);

  /* Фирменный синий (используется на части поверхностей) */
  --tesalut-blue: #3b82f6;
  --tesalut-blue-hover: #60a5fa;
  --tesalut-blue-soft: rgba(59, 130, 246, 0.16);

  /* Тени */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.45);

  /* Навбар (переопределяем токены из navbar.css) */
  --nav-bg: rgba(15, 23, 42, 0.55);
  --nav-border: rgba(148, 163, 184, 0.16);
  --nav-hover-bg: rgba(148, 163, 184, 0.12);
  --nav-active-bg: rgba(59, 130, 246, 0.2);
  --nav-dropdown-bg: #1e293b;
  --nav-shadow: 0 10px 30px rgba(0, 0, 0, 0.55);

  color-scheme: dark;
}

/* Тёмный фон приложения — перекрывает светлый градиент body */
:root[data-theme='dark'] body {
  background: linear-gradient(-45deg,
      #0b1120 0%,
      #0f172a 40%,
      #111a2e 70%,
      #0b1120 100%);
  background-size: 260% 260%;
  background-attachment: fixed;
}

/* Общая страховка читаемости: базовая рамка панелей контента в тёмной теме */
:root[data-theme='dark'] .page-content {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

@media (prefers-reduced-motion: reduce) {

  *,
  ::before,
  ::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

body {
  font-family: var(--font-body);
  background: linear-gradient(-45deg,
      #f0f9ff 0%,
      #e0f2fe 22%,
      #eff6ff 45%,
      #f1f5f9 70%,
      #f8fafc 100%);
  background-size: 260% 260%;
  background-attachment: fixed;
  animation: meshGradientReveal 24s ease-in-out infinite;
  color: var(--text-primary);
  line-height: 1.6;
  min-height: 100vh;
  margin: 0;
  transition: color 0.3s ease-out;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Users page: disable expensive animated body background during long wheel scrolling */
body.users-scroll-optimized {
  animation: none;
  transition: color 0.2s ease-out;
}

@keyframes meshGradientReveal {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* Shared page open animation (taken from Home "fadeIn") */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-heading);
  color: var(--text-heading);
  font-weight: 600;
}

/* Navigation styles */
nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--bg-primary);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}

.nav-logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a202c;
}

.nav-menu {
  display: flex;
  gap: 8px;
}

.nav-button {
  position: relative;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
  overflow: hidden;
}

.nav-button:hover {
  color: #1a202c;
  background-color: var(--nav-hover-bg);
}

.nav-button.active {
  background-color: #e0f2fe;
  color: #2563eb;
}

.nav-button::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #2563eb;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.nav-button:hover::after {
  transform: translateX(0);
}

.navbar-user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Strict Loader */
.strict-loader {
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-color);
  border-top-color: var(--accent-primary);
  border-radius: 50%;
  animation: strict-spin 0.8s linear infinite;
  box-sizing: border-box;
  flex-shrink: 0;
}

@keyframes strict-spin {
  to {
    transform: rotate(360deg);
  }
}

.navbar-user-info .user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 0.875rem;
  color: #4b5563;
}

.navbar-user-info .user-details .role {
  margin-top: 4px;
  padding: 2px 8px;
  background-color: var(--nav-hover-bg);
  border-radius: 12px;
  font-size: 0.75rem;
}

.logout-button {
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #dc2626;
  background-color: #fee2e2;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.logout-button:hover {
  background-color: #fecaca;
}

/* Глобальный класс для основного контента с учетом навигации */
.main-content {
  margin-top: 80px;
  min-height: calc(100vh - 80px);
  padding: 24px 20px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  isolation: isolate;
  position: relative;
  z-index: 0;
  contain: layout style;
}

/* Глобальный нижний бар — copyright на каждой странице приложения */
.app-footer {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 20px 28px;
  text-align: center;
  font-size: 0.85rem;
  /* Цвет как у текста навбара, но слегка приглушённый — чуть светлее */
  color: var(--nav-text-muted);
  opacity: 0.75;
  border-top: 1px solid var(--border-color);
}

/* Page content styles - теперь используем .page-content внутри .main-content */
.page-content {
  padding: 24px;
  background-color: var(--bg-primary);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 16px;
}

.page-subtitle {
  font-size: 1rem;
  color: #4b5563;
  margin-bottom: 24px;
}

/* Grid for dashboard cards */
.card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 768px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.card {
  background-color: var(--bg-primary);
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.card-icon {
  width: 32px;
  height: 32px;
  background-color: #e0f2fe;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 1.25rem;
}

.card-icon.blue {
  background-color: #e0f2fe;
  color: #2563eb;
}

.card-icon.green {
  background-color: #d1fae5;
  color: #059669;
}

.card-icon.purple {
  background-color: #ede9fe;
  color: #7c3aed;
}

.card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a202c;
}

.card-text {
  font-size: 0.875rem;
  color: #4b5563;
}

/* Updates section */
.updates-section {
  background-color: #f9fafb;
  padding: 24px;
  border-radius: 12px;
  margin-top: 32px;
}

.updates-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 12px;
}

.updates-list {
  list-style-type: disc;
  list-style-position: inside;
  font-size: 0.875rem;
  color: #4b5563;
}

.updates-list li+li {
  margin-top: 8px;
}

/* Table styles */
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

th {
  font-weight: 600;
  color: #1a202c;
}

tr:hover {
  background-color: #f9fafb;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .nav-content {
    flex-direction: column;
    height: auto;
    padding: 16px 0;
  }

  .nav-menu {
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
  }

  .navbar-user-info {
    margin-top: 16px;
  }

  .main-content {
    margin-top: 120px;
    /* Больше места для мобильной навигации */
    padding: 16px;
  }
}
/* ============================================================
   ТЁМНАЯ ТЕМА — глобальные утилитарные классы оболочки.
   Некоторые из этих классов используют захардкоженные светлые
   цвета (тёмный текст / белый фон). Переопределяем их под тёмный
   фон, чтобы текст не сливался и поверхности были единообразны.
   Доступно только роли DEV — переключатель в навбаре.
   ============================================================ */
:root[data-theme='dark'] .page-content {
  background-color: var(--bg-card);
}

:root[data-theme='dark'] .page-title,
:root[data-theme='dark'] .card-title,
:root[data-theme='dark'] .updates-title {
  color: var(--text-heading);
}

:root[data-theme='dark'] .page-subtitle,
:root[data-theme='dark'] .card-text,
:root[data-theme='dark'] .updates-list {
  color: var(--text-secondary);
}

:root[data-theme='dark'] .card {
  background-color: var(--bg-card);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .updates-section {
  background-color: var(--bg-tertiary);
}

:root[data-theme='dark'] th {
  color: var(--text-heading);
}

:root[data-theme='dark'] th,
:root[data-theme='dark'] td {
  border-bottom-color: var(--border-color);
}

:root[data-theme='dark'] tr:hover {
  background-color: var(--bg-tertiary);
}

/* Легаси-навигация (.nav-*) — актуальный навбар в navbar.css, но
   подстрахуемся, чтобы ничего не осталось светлым. */
:root[data-theme='dark'] .nav-logo,
:root[data-theme='dark'] .navbar-user-info .user-details {
  color: var(--text-secondary);
}

:root[data-theme='dark'] .nav-button {
  color: var(--text-secondary);
}

:root[data-theme='dark'] .nav-button:hover {
  color: var(--text-primary);
}

:root[data-theme='dark'] .nav-button.active {
  background-color: var(--nav-active-bg);
  color: var(--accent-hover);
}

:root[data-theme='dark'] .card-icon.blue {
  background-color: rgba(59, 130, 246, 0.16);
  color: #93c5fd;
}

:root[data-theme='dark'] .card-icon.green {
  background-color: rgba(52, 211, 153, 0.16);
  color: #6ee7b7;
}

:root[data-theme='dark'] .card-icon.purple {
  background-color: rgba(167, 139, 250, 0.18);
  color: #c4b5fd;
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+FAA+F;AAC/F;EACE,iCAAiC;AACnC;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,2CAA2C;EAC3C,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;;EAEvC,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;;EAEvB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,uEAAuE;EACvE,qCAAqC;EACrC,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;;EAEvB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;;EAEtC,wBAAwB;EACxB,0CAA0C;EAC1C,8CAA8C;EAC9C,iBAAiB;EACjB,mBAAmB;;EAEnB,eAAe;EACf,uEAAuE;EACvE,+CAA+C;EAC/C,mCAAmC;;EAEnC,mBAAmB;AACrB;;AAEA;;;;;;iEAMiE;AACjE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,uCAAuC;EACvC,yCAAyC;EACzC,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;;EAEjC,wDAAwD;EACxD,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;;EAEpB,yCAAyC;EACzC,yBAAyB;EACzB,qCAAqC;EACrC,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;;EAEvB,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,wCAAwC;;EAExC,yDAAyD;EACzD,uBAAuB;EACvB,6BAA6B;EAC7B,6CAA6C;;EAE7C,SAAS;EACT,yCAAyC;EACzC,+CAA+C;;EAE/C,iDAAiD;EACjD,gCAAgC;EAChC,uCAAuC;EACvC,yCAAyC;EACzC,wCAAwC;EACxC,0BAA0B;EAC1B,6CAA6C;;EAE7C,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE;;;;mBAIiB;EACjB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,6EAA6E;AAC7E;EACE,yCAAyC;AAC3C;;AAEA;;EAEE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA;EACE,6BAA6B;EAC7B;;;;;mBAKiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,sDAAsD;EACtD,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,uFAAuF;AACvF;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;;;EAME,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,mCAAmC;EACnC,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,qEAAqE;EACrE,4BAA4B;EAC5B,aAAa;EACb,yCAAyC;AAC3C;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yCAAyC;IACzC,aAAa;EACf;AACF;AACA;;;;;;iEAMiE;AACjE;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;qDACqD;AACrD;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Fira+Code:wght@400;500;600;700&family=Fira+Sans:wght@300;400;500;600;700&display=swap');\n\n/* Base styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* GPU-accelerate the main scrolling layer so wheel events don't repaint fixed glass elements */\nbody {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Global Theme Variables (Animated Glass Theme) */\n:root {\n  /* Light Mode Base */\n  --bg-primary: #f8fafc;\n  --bg-glass: rgba(255, 255, 255, 0.7);\n  --bg-glass-heavy: rgba(255, 255, 255, 0.85);\n  --border-glass: rgba(255, 255, 255, 0.5);\n  --bg-secondary: rgba(248, 250, 252, 0.6);\n  --bg-tertiary: rgba(241, 245, 249, 0.6);\n\n  /* Text */\n  --text-primary: #0F172A;\n  --text-secondary: #475569;\n  --text-heading: #020617;\n\n  /* Accents */\n  --accent-primary: #2563EB;\n  /* Trust Blue */\n  /* Backward-compatible alias: some page CSS still uses --accent-color */\n  --accent-color: var(--accent-primary);\n  --accent-hover: #1D4ED8;\n  --accent-warning: #D97706;\n  --accent-success: #059669;\n  --accent-error: #DC2626;\n\n  /* Borders and UI */\n  --border-color: #E2E8F0;\n  --border-focus: rgba(37, 99, 235, 0.4);\n\n  /* Shadows and Effects */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  --glow-text: none;\n  --glow-accent: none;\n\n  /* Typography */\n  --font-body: 'Fira Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  --font-heading: 'Inter', 'Fira Code', monospace;\n  --font-data: 'Fira Code', monospace;\n\n  color-scheme: light;\n}\n\n/* ============================================================\n   ТЁМНАЯ ТЕМА (доступна только роли DEV — переключатель в навбаре)\n   Переопределяем базовые токены дизайн-системы. Все компоненты,\n   которые используют var(--token), автоматически становятся\n   тёмными. Специфичность :root[data-theme='dark'] выше, чем у\n   :root в других файлах, поэтому переопределение всегда выигрывает.\n   ============================================================ */\n:root[data-theme='dark'] {\n  /* Поверхности */\n  --bg-primary: #1e293b;\n  --bg-glass: rgba(30, 41, 59, 0.72);\n  --bg-glass-heavy: rgba(15, 23, 42, 0.9);\n  --border-glass: rgba(148, 163, 184, 0.14);\n  --bg-secondary: #1e293b;\n  --bg-tertiary: #273449;\n  --bg-card: rgba(30, 41, 59, 0.78);\n\n  /* Текст — высокий контраст, чтобы ничего не сливалось */\n  --text-primary: #f1f5f9;\n  --text-secondary: #aab7cc;\n  --text-heading: #f8fafc;\n  --text-muted: #8b98ae;\n  --text-main: #f1f5f9;\n\n  /* Акценты — чуть ярче для тёмного фона */\n  --accent-primary: #3b82f6;\n  --accent-color: var(--accent-primary);\n  --accent-hover: #60a5fa;\n  --accent-warning: #fbbf24;\n  --accent-success: #34d399;\n  --accent-error: #f87171;\n\n  /* Границы */\n  --border-color: #334155;\n  --border-light: rgba(148, 163, 184, 0.14);\n  --border-focus: rgba(59, 130, 246, 0.55);\n\n  /* Фирменный синий (используется на части поверхностей) */\n  --tesalut-blue: #3b82f6;\n  --tesalut-blue-hover: #60a5fa;\n  --tesalut-blue-soft: rgba(59, 130, 246, 0.16);\n\n  /* Тени */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.45);\n\n  /* Навбар (переопределяем токены из navbar.css) */\n  --nav-bg: rgba(15, 23, 42, 0.55);\n  --nav-border: rgba(148, 163, 184, 0.16);\n  --nav-hover-bg: rgba(148, 163, 184, 0.12);\n  --nav-active-bg: rgba(59, 130, 246, 0.2);\n  --nav-dropdown-bg: #1e293b;\n  --nav-shadow: 0 10px 30px rgba(0, 0, 0, 0.55);\n\n  color-scheme: dark;\n}\n\n/* Тёмный фон приложения — перекрывает светлый градиент body */\n:root[data-theme='dark'] body {\n  background: linear-gradient(-45deg,\n      #0b1120 0%,\n      #0f172a 40%,\n      #111a2e 70%,\n      #0b1120 100%);\n  background-size: 260% 260%;\n  background-attachment: fixed;\n}\n\n/* Общая страховка читаемости: базовая рамка панелей контента в тёмной теме */\n:root[data-theme='dark'] .page-content {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  *,\n  ::before,\n  ::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\nbody {\n  font-family: var(--font-body);\n  background: linear-gradient(-45deg,\n      #f0f9ff 0%,\n      #e0f2fe 22%,\n      #eff6ff 45%,\n      #f1f5f9 70%,\n      #f8fafc 100%);\n  background-size: 260% 260%;\n  background-attachment: fixed;\n  animation: meshGradientReveal 24s ease-in-out infinite;\n  color: var(--text-primary);\n  line-height: 1.6;\n  min-height: 100vh;\n  margin: 0;\n  transition: color 0.3s ease-out;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Users page: disable expensive animated body background during long wheel scrolling */\nbody.users-scroll-optimized {\n  animation: none;\n  transition: color 0.2s ease-out;\n}\n\n@keyframes meshGradientReveal {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n/* Shared page open animation (taken from Home \"fadeIn\") */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--font-heading);\n  color: var(--text-heading);\n  font-weight: 600;\n}\n\n/* Navigation styles */\nnav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: var(--bg-primary);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n.nav-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 64px;\n}\n\n.nav-logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a202c;\n}\n\n.nav-menu {\n  display: flex;\n  gap: 8px;\n}\n\n.nav-button {\n  position: relative;\n  padding: 8px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4b5563;\n  background: none;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  overflow: hidden;\n}\n\n.nav-button:hover {\n  color: #1a202c;\n  background-color: var(--nav-hover-bg);\n}\n\n.nav-button.active {\n  background-color: #e0f2fe;\n  color: #2563eb;\n}\n\n.nav-button::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #2563eb;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n}\n\n.nav-button:hover::after {\n  transform: translateX(0);\n}\n\n.navbar-user-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Strict Loader */\n.strict-loader {\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--border-color);\n  border-top-color: var(--accent-primary);\n  border-radius: 50%;\n  animation: strict-spin 0.8s linear infinite;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n@keyframes strict-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.navbar-user-info .user-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.navbar-user-info .user-details .role {\n  margin-top: 4px;\n  padding: 2px 8px;\n  background-color: var(--nav-hover-bg);\n  border-radius: 12px;\n  font-size: 0.75rem;\n}\n\n.logout-button {\n  padding: 8px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #dc2626;\n  background-color: #fee2e2;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.logout-button:hover {\n  background-color: #fecaca;\n}\n\n/* Глобальный класс для основного контента с учетом навигации */\n.main-content {\n  margin-top: 80px;\n  min-height: calc(100vh - 80px);\n  padding: 24px 20px;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  isolation: isolate;\n  position: relative;\n  z-index: 0;\n  contain: layout style;\n}\n\n/* Глобальный нижний бар — copyright на каждой странице приложения */\n.app-footer {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px 20px 28px;\n  text-align: center;\n  font-size: 0.85rem;\n  /* Цвет как у текста навбара, но слегка приглушённый — чуть светлее */\n  color: var(--nav-text-muted);\n  opacity: 0.75;\n  border-top: 1px solid var(--border-color);\n}\n\n/* Page content styles - теперь используем .page-content внутри .main-content */\n.page-content {\n  padding: 24px;\n  background-color: var(--bg-primary);\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.page-title {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 16px;\n}\n\n.page-subtitle {\n  font-size: 1rem;\n  color: #4b5563;\n  margin-bottom: 24px;\n}\n\n/* Grid for dashboard cards */\n.card-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n}\n\n@media (min-width: 768px) {\n  .card-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.card {\n  background-color: var(--bg-primary);\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.card-icon {\n  width: 32px;\n  height: 32px;\n  background-color: #e0f2fe;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  font-size: 1.25rem;\n}\n\n.card-icon.blue {\n  background-color: #e0f2fe;\n  color: #2563eb;\n}\n\n.card-icon.green {\n  background-color: #d1fae5;\n  color: #059669;\n}\n\n.card-icon.purple {\n  background-color: #ede9fe;\n  color: #7c3aed;\n}\n\n.card-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.card-text {\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n/* Updates section */\n.updates-section {\n  background-color: #f9fafb;\n  padding: 24px;\n  border-radius: 12px;\n  margin-top: 32px;\n}\n\n.updates-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 12px;\n}\n\n.updates-list {\n  list-style-type: disc;\n  list-style-position: inside;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.updates-list li+li {\n  margin-top: 8px;\n}\n\n/* Table styles */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n}\n\nth,\ntd {\n  text-align: left;\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\nth {\n  font-weight: 600;\n  color: #1a202c;\n}\n\ntr:hover {\n  background-color: #f9fafb;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .nav-content {\n    flex-direction: column;\n    height: auto;\n    padding: 16px 0;\n  }\n\n  .nav-menu {\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 16px;\n  }\n\n  .navbar-user-info {\n    margin-top: 16px;\n  }\n\n  .main-content {\n    margin-top: 120px;\n    /* Больше места для мобильной навигации */\n    padding: 16px;\n  }\n}\n/* ============================================================\n   ТЁМНАЯ ТЕМА — глобальные утилитарные классы оболочки.\n   Некоторые из этих классов используют захардкоженные светлые\n   цвета (тёмный текст / белый фон). Переопределяем их под тёмный\n   фон, чтобы текст не сливался и поверхности были единообразны.\n   Доступно только роли DEV — переключатель в навбаре.\n   ============================================================ */\n:root[data-theme='dark'] .page-content {\n  background-color: var(--bg-card);\n}\n\n:root[data-theme='dark'] .page-title,\n:root[data-theme='dark'] .card-title,\n:root[data-theme='dark'] .updates-title {\n  color: var(--text-heading);\n}\n\n:root[data-theme='dark'] .page-subtitle,\n:root[data-theme='dark'] .card-text,\n:root[data-theme='dark'] .updates-list {\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .card {\n  background-color: var(--bg-card);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .updates-section {\n  background-color: var(--bg-tertiary);\n}\n\n:root[data-theme='dark'] th {\n  color: var(--text-heading);\n}\n\n:root[data-theme='dark'] th,\n:root[data-theme='dark'] td {\n  border-bottom-color: var(--border-color);\n}\n\n:root[data-theme='dark'] tr:hover {\n  background-color: var(--bg-tertiary);\n}\n\n/* Легаси-навигация (.nav-*) — актуальный навбар в navbar.css, но\n   подстрахуемся, чтобы ничего не осталось светлым. */\n:root[data-theme='dark'] .nav-logo,\n:root[data-theme='dark'] .navbar-user-info .user-details {\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .nav-button {\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .nav-button:hover {\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .nav-button.active {\n  background-color: var(--nav-active-bg);\n  color: var(--accent-hover);\n}\n\n:root[data-theme='dark'] .card-icon.blue {\n  background-color: rgba(59, 130, 246, 0.16);\n  color: #93c5fd;\n}\n\n:root[data-theme='dark'] .card-icon.green {\n  background-color: rgba(52, 211, 153, 0.16);\n  color: #6ee7b7;\n}\n\n:root[data-theme='dark'] .card-icon.purple {\n  background-color: rgba(167, 139, 250, 0.18);\n  color: #c4b5fd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
